import React, { useState, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import HeaderComponent from 'components/HeaderComponent';
import * as UIcons from '@iconscout/react-unicons';
// import Btn from 'components/Btn';
import SocialMediaForm from './SocialMediaForm';
import { withTranslation } from 'react-i18next';
import { SocialMediaValidation } from 'pages/Settings/validation';


export default withTranslation()(function SocialMedia({ t, info }) {
  const [state, setState] = useState(null);

  const [defaults, setDefaults] = useState({})
  useEffect(() => { 
    if (info?.extrat_data?.length || info?.extrat_data?.hasOwnProperty('social_media')) {

      setDefaults(JSON.parse(info?.extrat_data?.social_media))
    } 
  }, [info])

  const method = useForm({
    mode: 'all',
    resolver: yupResolver(SocialMediaValidation)
  })

  const { reset } = method;

  useEffect(() => {
    reset(info);
  }, [info, reset]);

  const action = (action) => {
    setState(action === 'close' ? null : action)
  }


  return (
    <FormProvider {...method}>
      <form className="w-full bg-white py-8 px-4 md:px-12 rounded-xl shadow-sm">
        <HeaderComponent title="Social media" hideBtn={true} />

        <ul className="w-full">
          <li className="w-full py-3 md:p-6 grid md:grid-cols-3 gap-5 border-b">
            <div className="flex items-center">
              <UIcons.UilFacebook className="text-secondary mr-2" size={28} />
              <label className="font-medium text-dark-blue text-lg">Facebook</label>
            </div>

            {
              state !== 'facebook' ? (
                <div className="w-full col-span-2 flex items-center justify-end">
                  <label className="font-medium text-dark-blue">{defaults?.facebook} </label>
                  <UIcons.UilEditAlt
                    className="text-primary ml-2"
                    size={20}
                    onClick={() => action('facebook')}
                  />
                </div>
              ) : (<SocialMediaForm defaultValue={defaults} info={info} name="facebook" action={action} />)
            }
          </li>

          <li className={`w-full py-3 md:p-6 grid md:grid-cols-3 gap-5 border-b`}>

            <div className="flex items-center">
              <UIcons.UilInstagramAlt className="text-secondary mr-2" size={28} />
              <label className="font-medium text-dark-blue text-lg">Instagram</label>
            </div>



            {
              state !== 'instagram' ? (
                <div className="w-full col-span-2 flex items-center justify-end">
                  <label className="font-medium text-dark-blue">{defaults?.instagram}</label>
                  <UIcons.UilEditAlt
                    className="text-primary ml-2"
                    size={20}
                    onClick={() => action('instagram')}
                  />
                </div>
              ) : (<SocialMediaForm defaultValue={defaults} info={info} name="instagram" action={action} />)
            }

          </li>

          <li className={`w-full py-3 md:p-6 grid md:grid-cols-3 gap-5 border-b`}>

            <div className="flex items-center">
              <UIcons.UilTwitter className="text-secondary mr-2" size={28} />
              <label className="font-medium text-dark-blue text-lg">Twitter</label>
            </div>


            {
              state !== 'twitter' ? (
                <div className="w-full col-span-2 flex items-center justify-end">
                  <label className="font-medium text-dark-blue">{defaults?.twitter}</label>
                  <UIcons.UilEditAlt
                    className="text-primary ml-2"
                    size={20}
                    onClick={() => action('twitter')}
                  />
                </div>
              ) : (<SocialMediaForm defaultValue={defaults} info={info} name="twitter" action={action} />)
            }

          </li>

          <li className={`w-full py-3 md:p-6 grid md:grid-cols-3 gap-5 border-b`}>

            <div className="flex items-center">
              <UIcons.UilTwitter className="text-secondary mr-2" size={28} />
              <label className="font-medium text-dark-blue text-lg">LinkedIn</label>
            </div>


            {
              state !== 'linkedIn' ? (
                <div className="w-full col-span-2 flex items-center justify-end">
                  <label className="font-medium text-dark-blue">{defaults?.linkedIn}</label>
                  <UIcons.UilEditAlt
                    className="text-primary ml-2"
                    size={20}
                    onClick={() => action('linkedIn')}
                  />
                </div>
              ) : (<SocialMediaForm defaultValue={defaults} info={info} name="linkedIn" action={action} />)
            }

          </li>
        </ul>
      </form>
    </FormProvider>
  )
})